import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import {
  legacy_createStore as createStore,
  applyMiddleware,
  compose,
} from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import reducers from "./reducers";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { HelmetProvider } from "react-helmet-async";
import ReactGA from "react-ga4";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

ReactGA.initialize("G-21WC2VDTB1");

const root = ReactDOM.createRoot(document.getElementById("root"));

// Check for the Redux DevTools extension
let composeEnhancers = compose;
if (
  process.env.NODE_ENV === "development" &&
  typeof window === "object" &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
) {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({});
}

const enhancer = composeEnhancers(applyMiddleware(thunk));
export const queryClient = new QueryClient();

root.render(
  <Provider store={createStore(reducers, enhancer)}>
    <GoogleOAuthProvider
      clientId={process.env.REACT_APP_SOCIAL_AUTH_GOOGLE_OAUTH2_KEY}
    >
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <HelmetProvider>
            <App />
          </HelmetProvider>
        </BrowserRouter>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </GoogleOAuthProvider>
  </Provider>
);
